import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Chat } from './pages/Chat'
import { Integrations } from './pages/Integrations'
import { LandingPage } from './features/landing/LandingPage'
import { useAuthStore } from './stores/authStore'
import { onSessionExpired } from './services/api'

const YTEST_URL = import.meta.env.VITE_YTEST_URL || 'https://ytest.ai'

export default function App() {
  const logout = useAuthStore((state) => state.logout)

  useEffect(() => {
    const unsubscribe = onSessionExpired(() => {
      logout()
      const returnUrl = encodeURIComponent(window.location.href)
      window.location.href = `${YTEST_URL}/login?return_to=${returnUrl}&expired=true`
    })
    return unsubscribe
  }, [logout])

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/app/chat"
        element={
          <ProtectedRoute>
            <Layout>
              <Chat />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/integrations"
        element={
          <ProtectedRoute>
            <Layout>
              <Integrations />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/app/chat" replace />} />
    </Routes>
  )
}
